/** Auto-generated from English – edit as needed. */
export default {
  'nav.home': 'Lar',
  'nav.seeDemo': 'Ver demo',
  'nav.howItWorks': 'Como funciona',
  'nav.pricing': 'Preços',
  'nav.aboutUs': 'Sobre nós',
  'nav.faqs': 'Perguntas frequentes',
  'nav.contact': 'Contato',
  'nav.careers': 'Carreiras',
  'nav.blog': 'Blogue',
  'nav.logIn': 'Entrar / Cadastrar',
  'nav.getStarted': 'Comece',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'A partir de apenas $ 2 por mês!',
  'hero.subscriptionsOnly': '( Apenas assinaturas )',
  'hero.couponBannerText': 'Cupom de 10% de desconto vitalício para nossos primeiros 1000 usuários!',
  'hero.couponSubscribedOnly': '(apenas assinantes)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'Plataforma de assinatura eletrônica · Planos a partir de US$ 2/mês',
  'hero.bannerHeadlinePrefix': 'Obtenha',
  'hero.bannerHeadlineMid': 'Assinados',
  'hero.bannerHeadlineAccent': 'Na hora.',
  'hero.bannerCycleContracts': 'Contratos',
  'hero.bannerCycleNDAs': 'NDAs',
  'hero.bannerCycleProposals': 'Propostas',
  'hero.bannerCycleDocuments': 'Documentos',
  'hero.bannerDesc':
    'Crie acordos profissionais, envie para assinatura eletrônica e receba PDFs assinados juridicamente válidos — em minutos, em qualquer dispositivo.',
  'hero.watchDemo': 'Veja como funciona',
  'hero.trustLocked': 'Encriptação AES-256',
  'hero.trustNoCard': 'Sem cartão necessário',
  'hero.trustReady': 'Ativo em 2 minutos',
  'hero.landingShowMore': 'Mostrar mais',
  'hero.landingShowLess': 'Mostrar menos',
  'hero.tagline': 'A forma mais fácil de criar, assinar e enviar documentos — sem fidelização',
  'hero.firebaseTopAria': 'Segurança e hospedagem (Google Firebase e Google Cloud)',
  'hero.topTrustListAria': 'Segurança, preços, assinatura, lembretes e suporte',
  'hero.accDataSafeTitle': 'Os seus dados estão seguros connosco',
  'hero.accDataSafe1':
    'Alimentado por Google Firebase e Google Cloud — a mesma infraestrutura de nível empresarial em que milhões de aplicações em todo o mundo confiam',
  'hero.accDataSafe2':
    'Os seus dados estão protegidos com encriptação AES-256 em repouso, com chaves geridas pela Google',
  'hero.accDataSafe3':
    'Autenticação segura e tratamento de dados nos padrões de segurança líderes da Google',
  'hero.accDataSafe4': 'Nunca vendemos nem partilhamos os seus dados; a sua privacidade é sempre respeitada',
  'hero.accDataSafe5Before': 'Transparência total sobre como os seus dados são armazenados e utilizados (veja a nossa ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'Preços simples e acessíveis — sem taxas ocultas',
  'hero.accPricing1': 'Crie acordos profissionais em minutos',
  'hero.accPricing2': 'Planos a partir de apenas US$ 2 por mês',
  'hero.accPricing3': 'Sem taxas ocultas nem custos surpresa',
  'hero.accPricing4': 'Sem fidelização — cancele quando quiser',
  'hero.accPricing5': 'Ideal para freelancers, startups e pequenas empresas',
  'hero.accPricing6': 'Envie o seu primeiro documento gratuitamente para começar',
  'hero.accSigningTitle': 'Assinatura de documentos rápida e fácil',
  'hero.accSigning1': 'Escolha entre mais de 30 modelos prontos ou envie o seu próprio ficheiro',
  'hero.accSigning2': 'Adicione campos de assinatura e personalize o documento em segundos',
  'hero.accSigning3': 'Envie documentos para vários destinatários de uma vez',
  'hero.accSigning4': 'Guarde modelos para reutilizar',
  'hero.accSigning5': 'Os destinatários não precisam de conta — podem assinar na hora',
  'hero.accSigning6': 'Pré-visualização em tempo real para garantir que o documento fica perfeito antes do envio',
  'hero.accRemindersTitle': 'Lembretes inteligentes e acompanhamento',
  'hero.accReminders1': 'Lembretes automáticos aos 1, 3 e 7 dias',
  'hero.accReminders2': 'Receba notificações quando um documento for aberto ou assinado',
  'hero.accReminders3': 'Acompanhe todo o processo de assinatura em tempo real',
  'hero.accReminders4': 'Pare de pedir assinaturas manualmente',
  'hero.accAnywhereTitle': 'Trabalhe de qualquer lugar',
  'hero.accAnywhere1': 'Aceda aos seus documentos no computador ou no telemóvel',
  'hero.accAnywhere2': 'Envie e assine a partir de qualquer dispositivo',
  'hero.accAnywhere3': 'Feito para flexibilidade — no escritório ou em deslocação',
  'hero.accSupportTitle': 'Suporte fiável',
  'hero.accSupport1': 'Apoio ao cliente dedicado com tempos de resposta rápidos',
  'hero.accSupport2': 'Objetivo de responder a todos os pedidos em até 24 horas',
  'hero.accSupport3': 'Atualizações e melhorias constantes com base no feedback dos utilizadores',
  'hero.firebaseTrustPrivacyLink': 'Política de privacidade',
  'hero.firebaseTrustFineprintAfter':
    ' explica a retenção de dados, o acesso e os seus direitos. Nunca vendemos os seus dados.',
  'hero.pill': 'Envie assinaturas eletrônicas legalmente vinculativas em segundos',
  'hero.headline': 'A ferramenta de assinatura eletrônica mais simples para freelancers e pequenas equipes',
  'hero.ctaPrimary': 'Criar / Enviar documento e enviar para assinatura',
  'hero.ctaTrialSignup': 'Iniciar teste grátis',
  'hero.ctaFreeDocument': 'Iniciar teste grátis',
  'hero.ctaPrimaryNote': '7 dias grátis. Cartão obrigatório. Depois, US$ 35/ano, salvo cancelamento.',
  'hero.subscriptionTeaserBefore': 'Subscrições a partir de apenas ',
  'hero.subscriptionTeaserAfter': ' por mês!',
  'hero.createAccountTrialHeadline': 'Comece seu teste grátis de 7 dias',
  'hero.createAccountPromoCopy': 'Copiar código',
  'hero.createAccountPromoCopied': 'Copiado!',
  'hero.createAccountPromoCodeAria': 'Código promocional: um mês de teste grátis',
  'hero.createAccountNote': 'Use no checkout ao escolher um plano.',
  'hero.createAccountOfferLimit': '( Oferta válida apenas para os nossos primeiros 1000 utilizadores )',
  'hero.desc': 'Ajuda indivíduos e equipes a criar, enviar e rastrear contratos com uma experiência de assinatura moderna.',
  'hero.getStartedFree': 'Comece gratuitamente',
  'hero.tryWithoutAccountButton': 'Experimente sem uma conta',
  'hero.logInSignUp': 'Entrar / Cadastrar',
  'hero.whyChooseUs': 'Por que nos escolher?',
  'hero.stepsTitle': 'Criar, Assinar, Receber',
  'hero.stepsSubtitle': 'Três passos simples para criar e assinar documentos em minutos.',
  'hero.step1Create': 'Carregue ou crie seu documento',
  'hero.step2Sign': 'Envie para assinatura',
  'hero.step3Receive': 'Seja notificado na hora quando for assinado',
  'hero.benefit1': 'Fácil de usar – Envie links de assinatura e e-mails em segundos',
  'hero.benefit2': 'Carregar PDF existente ou extrair texto e editar com o editor de texto rico',
  'hero.benefit3': 'Extraia texto de PDF existente e edite',
  'hero.benefit4': 'Crie campos e layouts de assinatura personalizados em segundos',
  'hero.benefit5': 'Envie para vários destinatários ao mesmo tempo',
  'hero.benefit7': 'Copie o link e envie para qualquer pessoa',
  'hero.benefit8': 'Crie e salve modelos',
  'hero.benefit9': 'Ver todos os eventos de e-mail',
  'hero.benefit10': 'Visualização ao vivo e PDFs prontos para auditoria',
  'hero.benefit11': 'Modelos avançados com edição flexível',
  'hero.benefit12': 'Não é necessária inscrição para destinatários',
  'hero.benefit13': 'Funciona em qualquer dispositivo, do desktop ao celular',
  'how.simpleProcess': 'Processo simples',
  'how.title': 'Como funciona',
  'how.subtitle': 'Crie, envie e faça login em três etapas simples.',
  'how.step1Title': 'Crie um modelo',
  'how.step1Desc': 'Extração e upload de PDF, editor de rich text (crie do zero ou cole e edite), campos de assinatura (data, nome completo, termos, blocos de assinatura), layout personalizado. Salve como modelo e reutilize a qualquer momento.',
  'how.step2Title': 'Enviar para destinatários',
  'how.step2Desc': 'Envie documentos por e-mail com links de assinatura exclusivos e seguros. Adicione vários destinatários por envio, copie links para compartilhar manualmente e acompanhe quando cada destinatário abre e conclui o documento.',
  'how.step3Title': 'Colete PDFs assinados',
  'how.step3Desc': 'Receba PDFs assinados verificados com trilha de auditoria completa: carimbo de data/hora, e-mail, telefone e consentimento. Receba e-mails de confirmação quando os signatários preencherem os documentos e mantenha cópias verificáveis ​​em seus registros.',
  'pricing.compareHeadline': 'Por que pagar $19/mês por assinaturas eletrônicas?',
  'pricing.comparePlatform': 'Plataforma',
  'pricing.comparePrice': 'Preço',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/mês',
  'pricing.compareBestValue': 'Melhor valor',
  'pricing.compareWhyPayLine1': 'Envie assinaturas eletrônicas legalmente vinculativas em segundos',
  'pricing.compareWhyPayLine2': 'Mais de um envio? Subscrições a partir de $2 por mês',
  'pricing.compareBenefitSingle': 'Envie documentos avulsos',
  'pricing.compareBenefitNoContract': 'Sem contratos caros',
  'pricing.compareBenefitPayWhenNeed': 'Pague só quando precisar',
  'pricing.compareBenefitTemplates': 'Escolha entre mais de 30 modelos',
  'pricing.compareDisclaimer': 'Preços de concorrentes com base em planos iniciais públicos e podem variar.',
  'trust.secureLinks': 'Links de assinatura únicos e seguros para cada documento',
  'trust.auditTrail': 'Trilha de auditoria completa em cada assinatura (quem, quando, IP)',
  'trust.verifiablePdfs': 'PDFs assinados verificáveis que você pode guardar',
  'trust.footer': 'Confiado por freelancers e pequenas empresas no mundo todo',
  'useCases.title': 'Ideal para todos os profissionais',
  'useCases.freelancers': 'Freelancers que enviam contratos',
  'useCases.agencies': 'Agências que assinam acordos',
  'useCases.landlords': 'Proprietários que enviam contratos de aluguel',
  'useCases.startups': 'Startups que assinam NDAs',
  'useCases.carBoat': 'Vender carro ou barco com documento legal',
  'useCases.consultants': 'Consultores e independentes',
  'useCases.equipmentRental': 'Alugar equipamentos com acordo formal',
  'useCases.contractors': 'Prestadores independentes formalizando trabalhos',
  'useCases.website': 'Acordos de projetos web e digitais',
  'pricing.title': 'Preços',
  'pricing.billAnnually': 'Faturar anualmente',
  'pricing.billMonthly': 'Faturar mensalmente',
  'pricing.getStarted': 'Comece',
  'pricing.mostPopular': 'MAIS POPULAR',
  'pricing.billedPerYear': 'Faturado em ${{amount}}/ano',
  'pricing.perMonth': '/ mês',
  'pricing.tierBasic': 'Básico',
  'pricing.tierStandard': 'Padrão',
  'pricing.tierPremium': 'Prêmio',
  'pricing.descBasic': 'Para uso ocasional.',
  'pricing.descStandard': 'Para equipes em crescimento.',
  'pricing.descPremium': 'Para usuários avançados com necessidades avançadas.',
  'about.label': 'Por que nos escolher',
  'about.title': 'Sobre nós',
  'about.subtitle': 'Tornamos os fluxos de trabalho de assinatura profissionais simples, rápidos e seguros para que você possa se concentrar em seus negócios.',
  'about.speed': 'Velocidade',
  'about.builtForSpeed': 'Construído para velocidade',
  'about.builtForSpeedDesc': 'Nossa interface de usuário moderna e responsiva permite criar e enviar documentos em minutos. Os signatários podem concluir contratos em qualquer dispositivo (desktop, tablet ou telefone) sem downloads ou configurações complexas.',
  'about.security': 'Segurança',
  'about.dataSecurity': 'Segurança de dados',
  'about.dataSecurityTitle': 'Alojado no Google Firebase e Google Cloud',
  'about.dataSecurityDesc': 'Os dados da sua conta, documentos, modelos e atividade de assinatura são processados no Google Firebase e no Google Cloud, plataformas concebidas para aplicações em produção que necessitam de autenticação e armazenamento robustos. O tráfego utiliza HTTPS (TLS) de ponta a ponta; os dados em repouso são encriptados com chaves geridas pela Google (incluindo AES-256). Os fluxos de início de sessão utilizam o Firebase Authentication, e as regras de segurança do Firestore ajudam a garantir que as leituras e escrita correspondem à sua conta, pelo que o seu espaço de trabalho permanece isolado e não é legível por toda a Internet. A infraestrutura corre na rede global da Google com práticas de monitorização, atualizações e durabilidade descritas na documentação da Google, e não vendemos os seus dados pessoais nem o conteúdo dos documentos a intermediários ou anunciantes. Para subcontratantes, programas de conformidade e os seus direitos, consulte a nossa Política de Privacidade.',
  'about.dataSecurityPrivacyCta': 'Ler a Política de Privacidade completa →',
  'about.privacyPill': 'Privacidade',
  'about.privacyFocused': 'Foco na privacidade',
  'about.privacyFocusedDesc': 'Cada ligação de assinatura é única: os destinatários só veem o que lhe enviar. Os PDFs assinados incluem um registo de auditoria claro que pode arquivar: quem assinou, quando e o consentimento que deram, para que privacidade e prova fiquem ligados.',
  'about.teams': 'Indivíduos e equipas',
  'about.madeForTeams': 'Feito para indivíduos e equipas',
  'about.madeForTeamsDesc': 'Quer assine sozinho ou em equipa, os nossos modelos facilitam. Crie documentos com texto formatado, títulos e listas. Adicione campos de assinatura, data, nome completo e campos personalizados (texto, caixa de verificação, etc.). Guarde modelos para acordos recorrentes e carregue-os a qualquer momento no histórico de modelos. Pré-visualize o PDF antes de enviar e envie para vários destinatários. Adicione anexos e acompanhe a atividade de e-mail nos planos que incluem estas funcionalidades.',
  'about.sectionHeadlineBefore': 'Construído para ',
  'about.sectionHeadlineAccent': 'confiança e rapidez',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'Perguntas frequentes',
  'faq.searchHint': 'Pesquise por palavra(s)-chave para encontrar rapidamente as FAQs',
  'faq.searchPlaceholder': 'ex.: PDF, modelo, assinatura...',
  'faq.noResults': 'Nenhuma FAQ corresponde à sua pesquisa. Tente outras palavras.',
  'faq.more': 'Mais',
  'faq.less': 'Menos',
  'faq.eyebrow': 'Tem dúvidas?',
  'faq.titleBefore': 'Perguntas ',
  'faq.titleAccent': 'frequentes',
  'faq.subtitleLead': 'Tudo o que precisa de saber sobre o Prime Document Sign. Não encontra a resposta? ',
  'faq.subtitleLink': 'Fale connosco.',
  'faq.clearSearchAria': 'Limpar pesquisa',
  'faq.subscriptionsWorkQ': 'Como funcionam as subscrições?',
  'faq.upgradePlanQ': 'Como faço upgrade do meu plano?',
  'faq.upgradePlanA': 'Vá a A minha conta → A minha subscrição, escolha um nível superior (ex.: Padrão ou Premium) e confirme. O upgrade costuma aplicar-se de imediato. Pode ser cobrado um valor proporcional até ao fim do período de faturação. Os novos limites (e-mails, modelos, anexos) aplicam-se logo.',
  'faq.downgradePlanQ': 'Como faço downgrade do meu plano?',
  'faq.downgradePlanA': 'Vá a A minha conta → A minha subscrição, escolha um nível inferior e confirme. O downgrade aplica-se no início do próximo ciclo de faturação. Mantém o plano atual até lá. Sem reembolsos pela diferença. Depois, os limites reduzem-se ao do novo nível.',
  'faq.cancelPlanQ': 'Como cancelo a minha subscrição?',
  'faq.cancelPlanA': 'Vá a A minha conta → A minha subscrição e cancele pelo portal de clientes Stripe ou contacte o apoio. O cancelamento produz efeitos no fim do período de faturação em curso. Mantém o acesso até lá. Sem reembolsos proporcionais. Findo o período, o acesso termina e pode voltar a registar-se quando quiser.',
  'faq.emailLimitQ': 'O que acontece quando atinjo o limite mensal de e-mails?',
  'faq.yearlyBillingQ': 'Suportam faturação anual?',
  'faq.yearlyBillingA': 'Sim. O Premium oferece faturação mensal ou anual: ${{monthly}}/mês ou ${{annual}}/ano. A faturação anual poupa até {{discountPercent}}% face ao mensal. Escolha no registo ou altere em A minha subscrição.',
  'faq.multipleRecipientsQ': 'Posso enviar para vários destinatários?',
  'faq.multipleRecipientsA': 'Sim. O Básico suporta até 5 destinatários por envio; Padrão e Premium até 10. Indique os e-mails separados por vírgulas. Cada destinatário recebe uma ligação de assinatura única e pode concluir o documento de forma independente. Não é necessária conta.',
  'faq.reuseTemplatesQ': 'Posso reutilizar modelos?',
  'faq.reuseTemplatesA': 'O Básico inclui 3 modelos guardados, o Padrão 10 e o Premium 25. Use o Histórico de modelos (A minha conta) para carregar modelos guardados. Os modelos guardam o texto do acordo, formatação e campos de assinatura.',
  'faq.recipientAccountQ': 'O destinatário precisa de conta?',
  'faq.recipientAccountA': 'Não. O destinatário recebe o e-mail com a ligação e pode assinar diretamente no dispositivo. Sem conta. Funciona em computador, tablet e telemóvel.',
  'faq.confirmationEmailQ': 'Vou receber um e-mail de confirmação?',
  'faq.confirmationEmailA': 'Sim. Quando o documento é concluído, recebe automaticamente um e-mail de confirmação com o PDF assinado em anexo. Cada PDF inclui registo de auditoria verificável: data e hora, e-mail, telefone e consentimento.',
  'faq.previewPdfQ': 'Posso pré-visualizar o PDF antes de enviar?',
  'faq.previewPdfA': 'Sim. Use o botão Pré-visualizar PDF para ver o layout exato antes de enviar. Verifique formato e conteúdo e depois envie ou copie a ligação.',
  'faq.editAgreementQ': 'Posso editar o texto do acordo?',
  'faq.editAgreementA': 'Sim. Use o editor de texto rico para títulos, listas, negrito, itálico, sublinhado e tamanhos de letra. Também pode carregar um PDF para extrair texto ou mostrar o PDF completo com o acordo por baixo.',
  'faq.signatureRequiredQ': 'É obrigatória uma assinatura para submeter?',
  'faq.signatureRequiredA': 'Sim. Os destinatários devem preencher data, nome completo, aceitação dos termos e assinatura antes de submeter. Isto garante requisitos de validade em cada documento assinado.',
  'faq.attachmentsQ': 'Quantos anexos posso incluir?',
  'faq.attachmentsA': 'O Básico não inclui anexos. O Padrão permite até 3 anexos por e-mail (8 MB no total). O Premium até 10 anexos por e-mail (8 MB no total). Os anexos seguem com a ligação de assinatura.',
  'faq.emailActivityQ': 'O que é Atividade de e-mail e limites (Premium)?',
  'faq.emailActivityA': 'O Premium inclui Atividade de e-mail e limites. Abra em A minha conta para ver todo o envio de e-mails: que documentos, quando e para quem. Útil para conformidade e arquivo.',
  'faq.emailRemindersQ': 'Como funcionam os lembretes por e-mail?',
  'faq.emailRemindersA': 'No criador de documentos, passo 4 (Funcionalidades adicionais), pode ativar lembretes a 1, 3 e/ou 7 dias para cada envio. Depois do primeiro e-mail de assinatura, só enviamos um lembrete se esse destinatário ainda não tiver concluído o documento. Os lembretes param automaticamente quando assinam. Os e-mails de lembrete aparecem na Atividade de e-mail com data e hora; não contam para o limite mensal de envios.',
  'faq.defaultSenderQ': 'Posso definir um e-mail de remetente predefinido?',
  'faq.defaultSenderA': 'Sim. Vá a A minha conta → Dados da conta, introduza o e-mail preferido no campo E-mail predefinido e guarde. O campo De será preenchido automaticamente ao enviar documentos.',
  'faq.mobileSignQ': 'Os destinatários podem assinar no telemóvel?',
  'faq.mobileSignA': 'Sim. A experiência de assinatura é responsiva. Podem abrir a ligação num smartphone ou tablet, desenhar a assinatura com o dedo ou stylus e concluir o formulário em qualquer dispositivo.',
  'faq.getHelpQ': 'Como obtenho ajuda?',
  'faq.getHelpA': 'Use Contactar suporte em A minha conta ou o formulário de contacto no site. Tentamos responder rapidamente.',
  'faq.dataSecureQ': 'Os meus dados estão seguros?',
  'faq.dataSecureA': 'Sim. Usamos práticas à norma do setor para proteger os seus documentos e dados pessoais. Os documentos são transmitidos e armazenados de forma segura.',
  'faq.fileFormatsQ': 'Que formatos de ficheiro são suportados?',
  'faq.fileFormatsA': 'Os documentos são criados no nosso editor de texto rico. Os acordos concluídos são gerados como PDF, compatíveis para uso jurídico e empresarial.',
  'faq.deleteTemplateQ': 'O que acontece se apagar um modelo?',
  'faq.deleteTemplateA': 'Os modelos apagados são removidos de forma permanente e não podem ser recuperados. Confirme que já não precisa do modelo. Pode criar um novo a partir do documento atual em qualquer momento.',
  'faq.ownLogoQ': 'Posso adicionar o meu logótipo?',
  'faq.ownLogoA': 'Sim, nos planos Padrão e Premium. Carregue o logótipo (até 20 KB) e escolha a posição. Aparece na página de assinatura e no PDF assinado. O Básico não inclui esta função.',
  'faq.uploadPdfQ': 'Como carrego um PDF?',
  'faq.uploadPdfA': 'No criador de documentos, use Carregar PDF (planos Padrão e Premium). O PDF é mostrado por cima ou ao lado do texto do acordo. Os destinatários veem o documento completo ao assinar.',
  'faq.extractPdfQ': 'O que é extração de PDF e como funciona?',
  'faq.extractPdfA': 'A extração de PDF (Padrão e Premium) copia texto de um PDF existente para o editor para poder editar. Carregue o PDF, escolha Extrair texto, e o conteúdo é copiado para o editor. Depois pode alterar e adicionar campos de assinatura.',
  'faq.richTextEditorQ': 'O que posso fazer com o editor de texto rico?',
  'faq.richTextEditorA': 'O editor permite criar e formatar acordos: títulos, negrito, itálico, listas, tamanhos de letra. Adicione blocos de assinatura abaixo. Tudo por cliques, sem código.',
  'faq.previewWhenQ': 'Quando devo pré-visualizar antes de enviar?',
  'faq.previewWhenA': 'Use sempre Pré-visualizar PDF antes de enviar. Mostra o layout que os destinatários veem: texto, blocos de assinatura, data, nome. Verifique o formato e depois envie ou copie a ligação.',
  'faq.documentLifetimeQ': 'Quanto tempo duram as ligações de assinatura? Posso pedir uma extensão?',
  'faq.documentLifetimeA': 'As ligações costumam ficar ativas cerca de 30 dias. Descarregue e guarde o PDF assinado antes de expirar. Se tiver expirado, peça ao remetente um novo e-mail com uma ligação nova.',
  'faq.editLayoutQ': 'Como edito o layout da assinatura?',
  'faq.editLayoutA': 'Use Editar layout na secção de assinatura para reorganizar campos. Arraste data, nome completo, termos, blocos de assinatura e campos personalizados. Adicione espaçadores e escolha o número de colunas.',
  'faq.customFieldsQ': 'Como adiciono campos personalizados (texto, data, caixa, etc.)?',
  'faq.customFieldsA': 'Clique em Adicionar campo personalizado na secção de assinatura. Escolha etiqueta e tipo: Texto, Número, Data, Hora, Lista, Caixa ou Assinatura. Até 10 campos personalizados por documento. Indique que firmantes veem cada campo e use Editar layout para posicionar.',
  'faq.multipleSignaturesQ': 'Posso adicionar 2 ou mais assinaturas (vários signatários)?',
  'faq.multipleSignaturesA': 'Sim. Use Destinatários para adicionar um segundo signatário. Cada um recebe uma ligação única e o seu bloco de assinatura. Básico: até 5 destinatários por envio; Padrão e Premium: até 10.',
  'faq.documentBuilderTipsQ': 'O que posso fazer no criador de documentos?',
  'faq.documentBuilderTipsA': 'Criar acordos, carregar ou extrair PDFs, adicionar blocos de assinatura, campos personalizados e anexos. Editar layout, guardar modelos, pré-visualizar o PDF. As alterações guardam-se automaticamente.',
  'faq.clearEverythingQ': 'O que faz Limpar tudo?',
  'faq.clearEverythingA': 'Limpar tudo repõe o criador: texto do acordo, blocos de assinatura, campos personalizados e anexos. Use para começar um documento novo. Os modelos guardados não são afetados.',
  'faq.forgotPasswordQ': 'Esqueci-me da palavra-passe. Como repõe-la?',
  'faq.forgotPasswordA': 'No ecrã de início de sessão, clique em Esqueci-me da palavra-passe. Introduza o e-mail da conta e envie a ligação de reposição. Verifique a caixa de entrada (e spam). A ligação expira—peça outra se necessário. Inicie sessão com a nova palavra-passe.',
  'faq.saveTemplateQ': 'Como guardo um documento como modelo?',
  'faq.saveTemplateA': 'Crie o documento e clique em Guardar modelo. Dê um nome e Guardar como novo. Aparece no Histórico de modelos (A minha conta). Para atualizar: carregue o modelo, altere e Guardar modelo → Atualizar modelo.',
  'faq.loadTemplateQ': 'Como carrego um modelo do histórico?',
  'faq.loadTemplateA': 'Vá a A minha conta → Histórico de modelos. Clique no modelo pretendido. Abre no criador com conteúdo e layout completos. Edite se necessário, adicione destinatários e envie.',
  'faq.templateLimitsQ': 'Quantos modelos posso guardar?',
  'faq.templateLimitsA': 'Básico: 3, Padrão: 10, Premium: 25 modelos. Cada um guarda texto, formatação, blocos de assinatura e layout. No limite: apague um antigo ou faça upgrade.',
  'faq.recipientNoEmailQ': 'E se o destinatário não recebeu o e-mail de assinatura?',
  'faq.recipientNoEmailA': 'Peça-lhe que verifique o spam. Use Copiar ligação para obter o URL e partilhe manualmente (mensagem, Slack, etc.). Ou reenvie o documento para o mesmo e-mail para uma ligação nova.',
  'faq.editAfterSendQ': 'Posso editar um documento depois de enviado?',
  'faq.editAfterSendA': 'Não. Após enviar, o conteúdo fica bloqueado. Para alterar: crie um documento novo com as atualizações e envie de novo. Rascunhos não enviados podem ser editados livremente.',
  'faq.changeAccountQ': 'Como altero o e-mail ou a palavra-passe da conta?',
  'faq.changeAccountA': 'Vá a A minha conta → Dados da conta. Atualize e-mail ou palavra-passe. Para palavra-passe: introduza a atual e a nova. Use Esqueci-me da palavra-passe no início de sessão se não se lembrar da atual.',
  'faq.browserSupportQ': 'Que navegadores e dispositivos são suportados?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (computador e telemóvel). Assinatura responsiva em smartphones e tablets. Use versões recentes. Sem necessidade de app.',
  'faq.copyLinkQ': 'Como copio uma ligação para partilhar em vez de enviar por e-mail?',
  'faq.copyLinkA': 'Após criar o documento, clique em Copiar ligação. O URL é copiado. Cole numa mensagem, e-mail ou Slack. Os destinatários podem assinar sem receber e-mail nosso.',
  'faq.resendDocumentQ': 'Posso reenviar um documento se o destinatário ainda não assinou?',
  'faq.resendDocumentA': 'Sim. Envie o mesmo documento outra vez para o mesmo ou outro e-mail. Cada envio cria uma ligação nova. Se a original expirou, reenviar dá uma ligação nova. Use Atividade de e-mail (Premium) para acompanhar envios.',
  'testimonials.eyebrow': 'DEPOIMENTOS',
  'testimonials.title': 'O que os nossos clientes dizem sobre nós.',
  'testimonials.quote1': 'O custo é o mais baixo do mercado. Comparei várias ferramentas e o Prime Document Sign oferece a melhor relação qualidade-preço e é muito fácil de usar.',
  'testimonials.quote2': 'Copiei um acordo do ChatGPT, editei em minutos e enviei para assinatura. Tudo em menos de 10 minutos.',
  'testimonials.quote3': 'Fiz tudo pelo telemóvel: criei o documento, adicionei os campos de assinatura e enviei durante a viagem. Muito prático.',
  'testimonials.quote4': 'Fácil de usar e preços justos. Sem custos ocultos. A minha equipa usa para contratos e NDAs e toda a gente aprendeu rapidamente.',
  'testimonials.quote5': 'Colei o texto do contrato, coloquei os blocos de assinatura e enviei. Os destinatários assinaram no mesmo dia. Exatamente o que precisava.',
  'testimonials.quote6': 'Usei no portátil e no telemóvel. A experiência é fluida em ambos. Melhor custo-benefício em assinatura eletrónica que encontrei.',
  'testimonials.prev': 'Anterior',
  'testimonials.next': 'Seguinte',
  'contact.title': 'Contacte-nos',
  'contact.subtitle': 'Tem perguntas? Adoraríamos ouvir de si.',
  'contact.eyebrow': 'Entre em contacto',
  'contact.headlineBefore': 'Vamos ',
  'contact.headlineAccent': 'conversar',
  'contact.responseTimeLabel': 'Prazo de resposta',
  'contact.responseTimeValue': 'Até 24 horas',
  'contact.secureLabel': 'Seguro e privado',
  'contact.secureValue': 'Encriptação AES-256',
  'contact.trustNoSpam': 'Sem spam, nunca',
  'contact.trustHumanSupport': 'Apoio humano real',
  'contact.firstName': 'Nome próprio',
  'contact.lastName': 'Apelido',
  'contact.email': 'E-mail',
  'contact.message': 'Mensagem',
  'contact.sendMessage': 'Enviar mensagem',
  'contact.required': '*',
  'contact.placeholderFirst': 'Introduza o seu nome',
  'contact.placeholderLast': 'Introduza o seu apelido',
  'contact.placeholderEmail': 'Introduza o seu e-mail',
  'contact.placeholderMessage': 'Diga-nos como podemos ajudar...',
  'contact.attachments': 'Anexos',
  'contact.attachmentsHint': 'Até 5 ficheiros, 2 MB no total',
  'contact.addFiles': '+ Adicionar ficheiros',
  'contact.addAttachmentsAria': 'Adicionar anexos',
  'contact.location': 'Localização (país ou região)',
  'contact.locationPlaceholder': 'ex.: Portugal, Reino Unido, UE',
  'contact.phone': 'Telefone (opcional)',
  'contact.phonePlaceholder': 'ex.: +351 912 345 678',
  'contact.company': 'Empresa ou organização (opcional)',
  'contact.companyPlaceholder': 'Nome da sua empresa',
  'contact.links': 'Indique aqui os links separados por vírgulas (opcional)',
  'contact.linksPlaceholder': 'ex.: https://exemplo.com/pagina1, https://exemplo.com/pagina2',
  'contact.errorFirstNameRequired': 'O nome próprio é obrigatório',
  'contact.errorLastNameRequired': 'O apelido é obrigatório',
  'contact.errorEmailRequired': 'O e-mail é obrigatório',
  'contact.errorEmailInvalid': 'Introduza um endereço de e-mail válido',
  'contact.errorMessageRequired': 'A mensagem é obrigatória',
  'contact.errorMessageTooLong': 'A mensagem deve ter no máximo {{max}} caracteres ({{current}}/{{max}})',
  'contact.errorAttachmentsCount': 'Máximo de {{max}} anexos permitido',
  'contact.errorAttachmentsSize': 'Os anexos não podem exceder {{maxMb}} MB no total ({{current}} MB)',
  'auth.forgotPassword': 'Esqueceu a palavra-passe?',
  'auth.backToLogIn': 'Voltar ao início de sessão',
  'auth.sendResetLink': 'Enviar link de redefinição',
  'auth.checkEmailReset': 'Consulte o seu e-mail para o link de redefinição.',
  'auth.emailLabel': 'E-mail',
  'auth.passwordLabel': 'Palavra-passe',
  'auth.firstNameLabel': 'Nome próprio',
  'auth.lastNameLabel': 'Apelido',
  'auth.enterEmail': 'Introduza o seu e-mail.',
  'auth.enterEmailPassword': 'Introduza o e-mail e a palavra-passe.',
  'auth.passwordMinLength': 'A palavra-passe deve ter pelo menos 8 caracteres.',
  'auth.passwordSpecial': 'A palavra-passe deve incluir um caractere especial.',
  'auth.passwordsNoMatch': 'As palavras-passe não coincidem.',
  'auth.signInWithGoogle': 'Iniciar sessão com Google',
  'auth.or': 'ou',
  'auth.logInFailed': 'Falha ao iniciar sessão.',
  'auth.signUpFailed': 'Falha no registo.',
  'auth.emailAlreadyInUse': 'Este e-mail já está em uso.',
  'auth.errorEmailInvalid': 'Introduza um endereço de e-mail válido.',
  'auth.resetEmailFailed': 'Falha ao enviar o e-mail de redefinição.',
  'connectionError.message': 'Problema de conexão. Verifique sua internet e atualize a página.',
  'connectionError.refresh': 'Atualizar página',
  'connectionError.tooManyRequests': 'Muitas tentativas. Tente novamente mais tarde.',
  'auth.emailPlaceholder': 'joao@exemplo.pt',
  'auth.passwordPlaceholder': 'Introduza a sua palavra-passe',
  'auth.firstNamePlaceholder': 'João',
  'auth.lastNamePlaceholder': 'Silva',
  'auth.confirmPasswordLabel': 'Confirmar palavra-passe',
  'auth.confirmPasswordPlaceholder': 'Repetir palavra-passe',
  'auth.passwordPlaceholderHint': 'Mín. 8 caracteres, inclua um caractere especial (!@#$...)',
  'auth.passwordBlurError': 'A palavra-passe deve ter pelo menos 8 caracteres e incluir um caractere especial (!@#$%^&*...).',
  'auth.manageSubscription': 'Gerir subscrição',
  'auth.subscribe': 'Subscrever',
  'auth.signUpForSubscription': 'Registar para subscrição',
  'auth.currentPlan': 'PLANO ATUAL',
  'auth.updatePlanHint': 'Atualize o seu plano no Stripe para obter mais créditos mensais. Os novos limites aplicam-se após a atualização.',
  'auth.updatePlanStripe': 'Atualize o plano, método de pagamento ou cancele no portal seguro do Stripe.',
  'auth.subscribeToPlan': 'Subscreva um plano para começar.',
  'auth.topUpCredits': 'Comprar créditos ({{label}}: ${{price}})',
  'pricing.featureRecipients5': 'Até 5 destinatários por envio',
  'pricing.featureRecipients10': 'Até 10 destinatários por envio',
  'pricing.featureEmails5': 'Máx. 5 e-mails por mês',
  'pricing.featureEmails50': 'Máx. 100 e-mails por mês',
  'pricing.featureEmails150': 'Máx. 300 e-mails por mês',
  'pricing.featureTemplates3': '3 modelos guardados',
  'pricing.featureTemplates10': '10 modelos guardados',
  'pricing.featureTemplates25': '25 modelos guardados',
  'pricing.featureChars3k': 'Limite de 3.000 caracteres',
  'pricing.featureChars20k': 'Limite de 20.000 caracteres',
  'pricing.featureChars30k': 'Limite de 30.000 caracteres',
  'pricing.featureAttachmentsNone': 'Sem anexos adicionais',
  'pricing.featureAttachments3': '3 anexos (8 MB no total)',
  'pricing.featureAttachments10': '10 anexos (8 MB no total)',
  'pricing.featurePdfUpload': 'Carregar PDF completo',
  'pricing.featureAuditTrail': 'Registo de auditoria completo',
  'pricing.featurePdfExtract': 'Extrair e editar texto do PDF',
  'pricing.featureCustomFields': 'Criar campos personalizados e editar layout',
  'pricing.featureCopyLink': 'Copiar link para assinar',
  'pricing.featureLogo': 'Carregar logótipo personalizado',
  'pricing.featureVerification': 'Verificação do destinatário',
  'pricing.oneTimeSendIncluded': '1 envio incluído (pague ${{price}} por cada adicional)',
  'pricing.oneTimeOneSendPremium': '1 envio com todas as funcionalidades Premium',
  'app.createYourDocument': 'Criar o seu documento',
  'app.backToApp': 'Voltar à app',
  'app.backToMainSite': 'Voltar ao site',
  'app.backShort': 'Voltar',
  'app.myAccount': 'A minha conta',
  'app.saveTemplate': 'Guardar modelo',
  'app.templatesUsed': 'Modelos utilizados',
  'app.templatesUsedSaved': '{{count}} modelos guardados',
  'app.startFromTemplate': 'Começar a partir do modelo',
  'app.startFromTemplateHint': 'Escolha um modelo para preencher o documento. Pode editá-lo após selecionar.',
  'app.signedInAs': 'Sessão iniciada como',
  'app.sendCredits': 'Créditos de envio',
  'app.freeSendBanner': 'Você tem 1 envio de e-mail grátis — use para enviar seu documento para assinatura. Assine quando quiser para mais.',
  'app.creditEqualsSend': '1 crédito = 1 envio por e-mail',
  'app.topUpCredits': 'Comprar créditos',
  'app.emailSends': 'envios por e-mail',
  'app.signedAgreements': 'acordos assinados',
  'app.usedAfterAllowance': '(usado após o limite mensal)',
  'app.sendForSignature': 'Enviar para assinatura',
  'app.recipientsSection': 'Enviar para',
  'app.fromNameOrg': 'Nome / Organização do remetente',
  'app.fromNamePlaceholder': 'O seu nome ou organização',
  'app.fromEmail': 'E-mail do remetente',
  'app.fromEmailPlaceholder': 'Endereço de e-mail do remetente',
  'app.recipientEmail': 'E-mail do destinatário',
  'app.recipientHint': 'Separados por vírgulas, até {{max}} destinatário(s)',
  'app.recipientPlaceholder': 'Endereço de e-mail do destinatário',
  'app.recipientTooltip': 'Exemplo: a@b.com, c@d.com, e@f.com',
  'app.previewPdf': 'Pré-visualizar PDF',
  'app.clearEverything': 'Limpar tudo',
  'app.clearEverythingTitle': 'Limpar documento, destinatários e rascunho guardado',
  'app.copyLink': 'Copiar link',
  'app.copyLinkSubscribersOnly': 'Copiar link (apenas para assinantes)',
  'app.generatingLink': 'A gerar link…',
  'app.sendEmail': 'Enviar e-mail',
  'app.agreementText': 'Texto do acordo',
  'app.uploadPdfExtract': 'Carregar PDF para extrair texto',
  'app.fullPdfUpload': 'Carregar PDF completo',
  'app.agreementPlaceholder': 'Clique aqui para começar e escrever o texto do acordo…',
  'app.attachments': 'Anexos',
  'app.attachmentsHint': 'Até 10 ficheiros, máx. 8 MB no total para entrega por e-mail.',
  'app.addAttachment': '+ Adicionar anexo',
  'app.signatureSection': 'Secção de assinatura',
  'app.totalSignatures': 'Total de assinaturas',
  'app.createNewField': 'Criar novo campo',
  'app.addField': 'Adicionar campo',
  'app.layout': 'Layout',
  'app.editLayout': 'Editar layout',
  'app.addFieldTooltip': 'Adicione um campo personalizado (texto, data, caixa de verificação ou assinatura) ao bloco de assinatura. Até {{max}} campos personalizados.',
  'app.date': 'Data',
  'app.datePlaceholder': 'aaaa/mm/dd',
  'app.termsConditions': 'Termos e condições',
  'app.fullName': 'Nome completo',
  'app.fullNamePlaceholder': 'Introduza o nome completo',
  'app.signature': 'Assinatura',
  'app.clickToSign': 'Clique para assinar',
  'app.termsAgree': 'Concordo com todos os termos e condições.',
  'app.phone': 'Telefone',
  'app.phonePlaceholder': 'Introduza o número de telefone',
  'app.enterFieldPlaceholder': 'Introduza {{label}}',
  'app.enterNumber': 'Introduza número',
  'app.selectOption': 'Selecionar...',
  'app.noFields': 'Sem campos',
  'app.newDocument': 'Novo documento',
  'app.templateLabel': 'Modelo: {{name}}',
  'app.forSubscribersOnly': 'Apenas para assinantes',
  'app.emailCredits': 'Créditos de e-mail',
  'app.creditHintDeliver': '1 crédito = 1 envio — clique em Enviar para entregar',
  'app.skipAuthTesting': 'Ignorar autenticação (para testes)',
  'app.agreementRequired': 'É necessário texto do acordo ou carregamento de PDF.',
  'app.agreementOrPdfRequired': 'É necessário texto do acordo ou um documento PDF.',
  'app.loadingPdf': 'A carregar PDF…',
  'app.clearConfirmTitle': 'Limpar tudo',
  'app.clearConfirmMessage': 'Tem a certeza que deseja limpar todos os campos e anexos?',
  'app.cancel': 'Cancelar',
  'app.clear': 'Limpar',
  'app.clearConfirmButton': 'Sim, limpar tudo',
  'footer.tagline': 'Secure e‑signing for modern users.',
  'footer.product': 'Product',
  'footer.templates': 'Templates',
  'footer.company': 'Company',
  'footer.contactSupport': 'Contact Support',
  'footer.copyright': '© 2026 primedocumentsign. All rights reserved.',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'auth.logIn': 'Iniciar sessão',
  'auth.loggingIn': 'A iniciar sessão…',
  'auth.getStarted': 'Começar',
  'auth.signUp': 'Registar',
  'auth.logInToManage': 'Inicie sessão para gerir e enviar documentos para assinatura.',
  'auth.startSending': 'Comece a enviar documentos com um plano de subscrição simples.',
  'auth.welcomeBack': 'Bem-vindo de volta',
  'auth.createAccount': 'Criar a sua conta',
  'auth.createAccountButton': 'Criar conta',
  'auth.termsConfirmStart': 'Confirmo que li e aceito os',
  'auth.termsConfirmEnd': '.',
  'auth.termsMustAccept': 'Aceite os Termos de Serviço para criar a sua conta.',
  'auth.continue': 'Continuar',
  'auth.continueWithGoogle': 'Continuar com Google',
  'auth.backToAccountDetails': 'Voltar aos dados da conta',
  'auth.backToSubscriptions': 'Voltar às subscrições',
  'auth.lookingForOneTimeUse': 'Precisa de uso único?',
  'auth.billAnnually': 'Faturar anualmente',
  'auth.billMonthly': 'Faturar mensalmente',
  'auth.creatingAccount': 'A criar conta…',
  'email.signSubject': 'Por favor assine este acordo',
  'email.signTitle': 'Documento para assinar',
  'email.signSubtitle': 'Foi solicitado que assine um documento',
  'email.fromLabel': 'De',
  'email.signBody': 'Clique no botão abaixo para abrir o documento e adicionar sua assinatura. Qualquer destinatário pode usar este link para aceder e assinar — sem conta ou subscrição necessária.',
  'email.signButton': 'Assinar documento',
  'email.copyLink': 'Ou copie este link:',
  'email.ignoreNote': 'Se não esperava este e-mail, pode ignorá-lo.',
  'modal.editFieldLayout': 'Editar layout dos campos',
  'modal.editFieldLayoutHint': 'Arraste os campos para reordenar ou mover entre colunas.',
  'modal.columns': 'Colunas',
  'modal.col': '{{n}} col',
  'modal.addSpace': '+ Adicionar espaço',
  'modal.fields': 'Campos',
  'modal.leftColumn': 'Coluna esquerda',
  'modal.rightColumn': 'Coluna direita',
  'modal.removeFromLayout': 'Remover {{name}} do layout?',
  'modal.space': 'espaço',
  'modal.yesRemove': 'Sim, remover',
  'modal.keepIt': 'Manter',
  'modal.emptySpace': 'Espaço vazio',
  'modal.dropFieldsHere': 'Largue os campos aqui',
  'modal.removedFromLayout': 'Removido do layout — clique em + para restaurar',
  'modal.saveLayout': 'Guardar layout',
  'modal.removeFromLayoutTitle': 'Remover do layout',
  'modal.restoreToLayout': 'Restaurar no layout',
  'modal.editCustomField': 'Editar campo personalizado',
  'modal.editCustomFieldHint': 'Altere a etiqueta, o tipo ou quais signatários veem este campo.',
  'modal.addCustomField': 'Adicionar campo personalizado',
  'modal.addCustomFieldHint': 'Crie um novo campo para o formulário de assinatura. Máx. 10 campos personalizados.',
  'modal.fieldLabel': 'Etiqueta do campo',
  'modal.fieldLabelPlaceholder': 'ex.: Nome da empresa',
  'modal.fieldType': 'Tipo de campo',
  'modal.displayContent': 'Conteúdo a mostrar (somente leitura para o destinatário, máx. 100 car.)',
  'modal.displayContentPlaceholder': 'ex.: Consulte os termos abaixo',
  'modal.picklistOptions': 'Opções da lista (máx. 10)',
  'modal.typeAndPressAdd': 'Escreva e prima Adicionar',
  'modal.add': 'Adicionar',
  'modal.addedToSignature': 'Adicionado à assinatura',
  'modal.addedToSignatureHint': 'Marque as caixas abaixo para adicionar o novo campo ao layout de assinatura',
  'modal.signature1': 'Assinatura 1',
  'modal.signature2': 'Assinatura 2',
  'modal.close': 'Fechar',
  'modal.save': 'Guardar',
  'modal.fieldLabelRequired': 'A etiqueta do campo é obrigatória',
  'modal.displayContentRequired': 'O conteúdo a mostrar é obrigatório para Texto',
  'modal.picklistOptionRequired': 'Adicione pelo menos uma opção à lista',
  'modal.selectOneSignature': 'Selecione pelo menos uma assinatura',
  'modal.signingSectionExceed': 'A secção de assinatura excederia o limite de {{limit}} KB. Remova conteúdo primeiro.',
  'modal.link': 'Link',
  'modal.linkTitle': 'Título do link',
  'modal.linkUrl': 'URL do link',
  'modal.linkTextPlaceholder': 'Texto do link',
  'modal.linkUrlPlaceholder': 'https://exemplo.com',
  'modal.agreementSizeLimitReached': 'Limite de tamanho do acordo atingido',
  'modal.characterLimitReached': 'Limite de caracteres atingido',
  'modal.agreementSizeLimitMessage': 'Atingiu o tamanho máximo do acordo ({{max}} KB). Remova conteúdo ou imagens antes de adicionar mais.',
  'modal.characterLimitMessage': 'Atingiu o limite máximo de caracteres ({{max}}). Remova texto antes de adicionar mais.',
  'modal.signingSectionLimitReached': 'Limite da secção de assinatura atingido',
  'modal.signingSectionLimitMessage': 'Atingiu o tamanho máximo da secção de assinatura ({{limit}} KB). Remova valores, assinaturas ou campos antes de adicionar mais.',
  'modal.ok': 'OK',
  'modal.addYourSignature': 'Adicionar a sua assinatura',
  'modal.signatureHint': 'Use o rato ou o trackpad para assinar.',
  'modal.clear': 'Limpar',
  'modal.saveSignature': 'Guardar assinatura',
  'modal.removeAttachment': 'Remover anexo',
  'modal.removeAttachmentConfirm': 'Tem a certeza que deseja remover "{{name}}" deste documento?',
  'modal.yesRemoveLabel': 'Sim, remover',
  'modal.removeLogo': 'Remover logo',
  'modal.removeLogoConfirm': 'Tem a certeza que deseja remover o seu logo deste documento?',
  'modal.textDisplay': 'Texto para mostrar',
  'modal.picklist': 'Lista de opções',
  'modal.number': 'Número',
  'modal.time': 'Hora',
  'modal.editLabel': 'Editar etiqueta',
  'modal.editField': 'Editar campo',
  'modal.text': 'Texto',
  'modal.checkbox': 'Caixa de verificação',
  'modal.date': 'Data',
  'modal.signature': 'Assinatura',
  'modal.typeHasDataHint': 'O tipo não pode ser alterado porque este campo já tem dados.',
  'modal.typeHasDataTitle': 'O tipo não pode ser alterado quando o campo tem dados',
  'modal.noKeepIt': 'Não, manter',
  'modal.yesDelete': 'Sim, eliminar',
  'modal.deleteTemplate': 'Eliminar modelo',
  'modal.deleteTemplateConfirm': 'Tem a certeza que deseja eliminar "{{name}}"? Esta ação não pode ser anulada.',
  'modal.removeAttachmentFromMessage': 'Tem a certeza que deseja remover "{{name}}" da sua mensagem?',
  'modal.readyToSend': 'Pronto para enviar?',
  'modal.recipientsLabel': 'Destinatário(s):',
  'modal.readyToSendSubtitle': 'Já pré-visualizou o documento e tem a certeza que deseja enviar? O(s) seguinte(s) destinatário(s) receberão este e-mail:',
  'modal.readyToSendNote': 'Ao fazer o download de um PDF - A assinatura pode ser cortada se o espaçamento correto não for aplicado. Verifique e ajuste conforme necessário antes de enviar.',
  'modal.no': 'Não',
  'modal.yesSend': 'Sim, enviar',
  'modal.accountAlreadyExists': 'Conta já existe',
  'modal.accountAlreadyExistsMessage': 'Este e-mail já está registado. Deseja iniciar sessão ou criar conta com outro e-mail?',
  'modal.useDifferentEmail': 'Usar outro e-mail',
  'modal.logIn': 'Iniciar sessão',
  'modal.logOut': 'Terminar sessão?',
  'modal.logOutSubtitle': 'Tem a certeza que deseja terminar a sessão?',
  'modal.yesLogOut': 'Sim, terminar sessão',
  'lang.en': 'English',
  'lang.es': 'Spanish',
  'lang.pt': 'Portuguese',
  'lang.ja': 'Japanese',
  'lang.zh': 'Chinese',
  'lang.hi': 'Hindi',
  'lang.fr': 'French',
  'lang.it': 'Italian',
  'lang.de': 'German',

  'templates.starter.nda.name': 'Acordo de confidencialidade (NDA)',
  'templates.starter.nda.scopeTitle': 'Acordo de confidencialidade',
  'templates.starter.freelance.name': 'Contrato de serviços freelance',
  'templates.starter.freelance.scopeTitle': 'Contrato de serviços freelance',
  'templates.starter.vehicle.name': 'Contrato de venda de veículo',
  'templates.starter.vehicle.scopeTitle': 'Contrato de venda de veículo',
  'templates.starter.rental.name': 'Contrato de arrendamento residencial',
  'templates.starter.rental.scopeTitle': 'Contrato de arrendamento residencial',
  'templates.starter.recruitment.name': 'Contrato de serviços de recrutamento',
  'templates.starter.recruitment.scopeTitle': 'Contrato de serviços de recrutamento',
  'templates.starter.loan.name': 'Acordo de empréstimo',
  'templates.starter.loan.scopeTitle': 'Acordo de empréstimo',
  'templates.starter.website.name': 'Contrato de desenvolvimento de site',
  'templates.starter.website.scopeTitle': 'Contrato de desenvolvimento de site',
  'templates.starter.roommate.name': 'Acordo de convivência',
  'templates.starter.roommate.scopeTitle': 'Acordo de convivência',
  'templates.starter.photography.name': 'Contrato de serviços de fotografia',
  'templates.starter.photography.scopeTitle': 'Contrato de serviços de fotografia',
  'templates.starter.shortterm-rental.name': 'Acordo de aluguel de curto prazo',
  'templates.starter.shortterm-rental.scopeTitle': 'Acordo de aluguel de curto prazo',
  'templates.starter.equipment-rental.name': 'Acordo de aluguel de equipamentos',
  'templates.starter.equipment-rental.scopeTitle': 'Acordo de aluguel de equipamentos',
  'templates.starter.independent-contractor.name': 'Acordo de prestador de serviços independente',
  'templates.starter.independent-contractor.scopeTitle': 'Acordo de prestador de serviços independente',
}
